export const LOAD_HOME_CONTENT = "LOAD_HOME_CONTENT";
export const LOAD_HOME_CONTENT_PENDING = "LOAD_HOME_CONTENT_PENDING";
export const LOAD_HOME_CONTENT_FULFILLED = "LOAD_HOME_CONTENT_FULFILLED";

export const LOAD_HOME_SERVICES = "LOAD_HOME_SERVICES";
export const LOAD_HOME_SERVICES_PENDING = "LOAD_HOME_SERVICES_PENDING";
export const LOAD_HOME_SERVICES_FULFILLED = "LOAD_HOME_SERVICES_FULFILLED";

export const LOAD_HOME_REVIEW = "LOAD_HOME_REVIEW";
export const LOAD_HOME_REVIEW_PENDING = "LOAD_HOME_REVIEW_PENDING";
export const LOAD_HOME_REVIEW_FULFILLED = "LOAD_HOME_REVIEW_FULFILLED";

export const LOAD_SERVICES_CONTENT = "LOAD_SERVICES_CONTENT";
export const LOAD_SERVICES_CONTENT_PENDING = "LOAD_SERVICES_CONTENT_PENDING";
export const LOAD_SERVICES_CONTENT_FULFILLED =
  "LOAD_SERVICES_CONTENT_FULFILLED";
export const LOAD_SERVICES_CONTENT_REJECTED = "LOAD_SERVICES_CONTENT_REJECTED";

export const INIT_LOAD_GALLERY = "INIT_LOAD_GALLERY";
export const INIT_LOAD_GALLERY_PENDING = "INIT_LOAD_GALLERY_PENDING";
export const INIT_LOAD_GALLERY_FULFILLED = "INIT_LOAD_GALLERY_FULFILLED";
export const INIT_LOAD_GALLERY_REJECTED = "INIT_LOAD_GALLERY_REJECTED";

export const INIT_LOAD_FEEDBACK = "INIT_LOAD_FEEDBACK";
export const INIT_LOAD_FEEDBACK_PENDING = "INIT_LOAD_FEEDBACK_PENDING";
export const INIT_LOAD_FEEDBACK_FULFILLED = "INIT_LOAD_FEEDBACK_FULFILLED";
export const INIT_LOAD_FEEDBACK_REJECTED = "INIT_LOAD_FEEDBACK_REJECTED";

export const LOAD_CONTACT_CONTENT = "LOAD_CONTACT_CONTENT";
export const LOAD_CONTACT_CONTENT_FULFILLED = "LOAD_CONTACT_CONTENT_FULFILLED";



// WEBPACK FOOTER //
// ./src/actions/types.js